//
//
//
//
//
//
//
//

export default {
	name: 'HelloWorld'
}
